/** GraphQL PolicyKind values (spec 031). */
export const POLICY_KIND = {
  TERMS: 'TERMS',
  PRIVACY: 'PRIVACY',
  CANCELLATION: 'CANCELLATION',
  ACCOUNT_DELETION: 'ACCOUNT_DELETION',
  HOST_AGREEMENT: 'HOST_AGREEMENT',
  RENTER_AGREEMENT: 'RENTER_AGREEMENT',
  CAR_SHARING_AGREEMENT: 'CAR_SHARING_AGREEMENT',
  PUBLISHER_DISCLAIMER: 'PUBLISHER_DISCLAIMER',
} as const;

export type PolicyKindName = (typeof POLICY_KIND)[keyof typeof POLICY_KIND];

export const POLICY_KIND_TITLES: Record<string, string> = {
  TERMS: 'Terms of Service',
  PRIVACY: 'Privacy Policy',
  CANCELLATION: 'Cancellation and Refund Policy',
  ACCOUNT_DELETION: 'Account Deletion Policy',
  HOST_AGREEMENT: 'Host Agreement',
  RENTER_AGREEMENT: 'Rental Agreement',
  CAR_SHARING_AGREEMENT: 'Car Sharing Agreement',
  PUBLISHER_DISCLAIMER: 'Legal Content Publishing Acknowledgment',
};

/** URL segment (`/policies/:doc`) to the GraphQL enum. */
const SLUG_TO_KIND: Record<string, PolicyKindName> = {
  terms: 'TERMS',
  privacy: 'PRIVACY',
  cancellation: 'CANCELLATION',
  'account-deletion': 'ACCOUNT_DELETION',
  'host-agreement': 'HOST_AGREEMENT',
  'renter-agreement': 'RENTER_AGREEMENT',
  'car-sharing-agreement': 'CAR_SHARING_AGREEMENT',
  'publisher-disclaimer': 'PUBLISHER_DISCLAIMER',
};

export function policyKindFromSlug(doc: string | undefined): PolicyKindName | null {
  if (!doc) return null;
  return SLUG_TO_KIND[doc] ?? null;
}

export function policySlugFromKind(kind: string): string {
  return (
    Object.entries(SLUG_TO_KIND).find(([, value]) => value === kind)?.[0] ?? kind.toLowerCase()
  );
}
